export default "__VITE_ASSET__4430f5fb__"